import { ANSWER_OPTIONS, CATEGORIES, RESOURCES, BOOKS } from "./data";

export function computeResults(answers) {
  // answers: { [questionId]: answerValue }
  const byCat = {};
  CATEGORIES.forEach((c) => (byCat[c.key] = []));

  // Build expanded answer objects later in submit; here only score math.
  Object.entries(answers).forEach(([qid, val]) => {
    const opt = ANSWER_OPTIONS.find((o) => o.value === Number(val));
    if (!opt) return;
    // we need category by qid -> derived from QUESTIONS index, but we accept full quiz items
  });

  return byCat;
}

export function scoreByCategory(answers, questions) {
  const buckets = {};
  CATEGORIES.forEach((c) => (buckets[c.key] = []));
  questions.forEach((q) => {
    const v = answers[q.id];
    if (v === undefined) return;
    const opt = ANSWER_OPTIONS.find((o) => o.value === Number(v));
    if (opt) buckets[q.category].push(opt.score);
  });
  const scores = {};
  CATEGORIES.forEach((c) => {
    const arr = buckets[c.key];
    scores[c.key] = arr.length
      ? Math.round(arr.reduce((a, b) => a + b, 0) / arr.length)
      : 0;
  });
  const general = Math.round(
    CATEGORIES.reduce((acc, c) => acc + scores[c.key], 0) / CATEGORIES.length
  );

  const sorted = [...CATEGORIES]
    .map((c) => ({ key: c.key, label: c.label, score: scores[c.key] }))
    .sort((a, b) => b.score - a.score);
  const strongest = sorted.slice(0, 3).map((s) => s.label);
  const development = [...sorted].sort((a, b) => a.score - b.score).slice(0, 3);
  const developmentLabels = development.map((s) => s.label);
  const developmentKeys = development.map((s) => s.key);

  const recommended_resources = developmentKeys.flatMap((k) =>
    RESOURCES[k].map((r) => ({ ...r, category: k }))
  );
  const recommended_books = developmentKeys.map((k) => ({
    key: k,
    ...BOOKS[k],
  }));

  return {
    scores,
    general,
    strongest,
    development: developmentLabels,
    developmentKeys,
    recommended_resources,
    recommended_books,
  };
}

export function levelText(score) {
  if (score >= 80) return "Çok iyi seviyedesin";
  if (score >= 60) return "İyi seviyedesin";
  if (score >= 40) return "Gelişime açıksın";
  return "Acil gelişim alanı";
}
